<template>
  <div id="app" class="viewport container-col">
    <!-- <div class="row-fit" contenteditable>
      row-fit-to-content
    </div>
    <div class="row-fill container-row">
      <div class="col-fit" contenteditable>
        col-fit-to-content
      </div>
      <div class="col-fill container-col-wrapped">
        <div class="wrappable-row-full" contenteditable>
          wrappable-row-full
        </div>
        <div class="wrappable-row-fit" contenteditable>
          wrappable-row-fit
        </div>
        <div class="wrappable-row-fixed" contenteditable>
          wrappable-row-fixed
        </div>
      </div>
      <div class="col-fixed" contenteditable>
        col-fixed-height
      </div>
    </div>
    <div class="row-fixed" contenteditable>
      row-fixed-height
    </div> -->
    <div class="row-fit">
      <Navbar/>
    </div>
    <router-view class="row-fill logo-in-bg"></router-view>
    <div class="row-fixed footer">
      Muraija <router-link :to="{name: 'static', params: { url: 'release_notes.html', theme: 'ltr' }}">v0.9.2 </router-link>
      |
      <router-link :to="{name: 'static', params: { url: 'privacy_policy.html',  theme: 'ltr' }}">privacy policy</router-link>
      <b v-if="devEnv">
      | backend: {{ backendServer }}
      | uid: {{ uid }}
      </b>
      <span class=footer-links>
        <router-link to="/changes"> recent changes </router-link> |
        <router-link to="/stats"> stats </router-link>
      </span>
    </div>
    <!-- <nav class="navbar navbar-toggleable-md">
      <a class="navbar-brand" href="#">
          <h1 class="navbar-brand mb-0">My App</h1>
      </a>
      <ul class="navbar-nav">
          <li class="nav-item"><a class="nav-link">Item 1</a></li>
      </ul>
    </nav> -->

  </div>
</template>

<script>
import Navbar from './components/Navbar.vue'
import { backendUrl } from './mixins/api'
import { auth } from './components/user-management/firebase.js'

import store from './store'

export default {
  name: 'app',
  components: {
    Navbar
  },
  created: function () {
    //console.log("App is created, uid in local storage:", localStorage.getItem('uid'))
    console.log("App is created, current user:", auth.currentUser)
  },
  computed: {
    devEnv: function () {
      return process.env.NODE_ENV === 'development'
    },
    backendServer: function () {
      return backendUrl
    },
    uid: function () {
      if (this.$store.state.user) {
        return this.$store.state.user.uid
      } else {
        return "none"
      }
    }
  }
}
</script>

<style>

/* Flex layout setup

Three container types:
 - container-row
 - container-col
 - container-col-wrap

Three element types
 - fit-to-content (overflow hide - should not happen)
 - fill remaining space (overflow scroll)
 - fixed height (overflow hide / scroll)
*/

.container-row, .container-col, .container-col-wrapped {
  display: flex;
}

.container-row {
  flex-direction: row
}

.container-col, .container-col-wrapped {
  flex-direction: column
}

/* Disable multicol layout on small screens*/
@media (min-width: 992px) {
  .container-col-wrapped {
    flex-wrap: wrap;
    align-content: start  /* align along cross axis, that is: put all cols next to another */
  }
}

/* Fit to content, do not shrink, do not grow.
   Only scroll along cross axis, to force growth along main axis,
   (a row scrolls horicontally, a col scrolls vertically) */

.row-fit, .col-fit {
  flex: none;
  overflow: auto;
}

.row-fit {
  overflow-y: hidden
}

.col-fit {
  overflow-x: hidden
}

/* Fill remaining space
   Allow scrolling both along main and cross axis (wanted?)
*/

.row-fill, .col-fill {
  flex: auto;
  overflow: auto
}

/* Fixed heigt (of 50px - USEFUL HERE?)
   No scolling
*/

.row-fixed, .col-fixed {
  flex: 0 0 20px;
  overflow: hidden;
}

/* Wrappable variants of row (of width 200px - USEFUL HERE?)
   Overwrites scrolling behaviour: We scroll along main axis, not along cross axis
*/

/* Disable multicol layout on small screens*/
@media (min-width: 992px) {
  .wrappable-row-fit, .wrappable-row-full, .wrappable-row-fixed {
    /* border: 1px solid black;
    margin: 20px; */
    width: 300px;
    overflow-x: hidden;
    overflow-y: auto;
  }
}

.wrappable-row-fit {
  flex: initial;
}

.wrappable-row-full {
  flex: 1 1 100%;
}

.wrappable-row-fixed {
  flex: 0 0 20px;
}

/* Debug colors */

/* .row-fit, .col-fit, .wrappable-row-fit {
  background-color:rgba(255, 0, 0.5);
}

.row-fill, .col-fill, .wrappable-row-full {
  background-color:rgba(0, 255, 0, 0.5);
}

.row-fixed, .col-fixed, .wrappable-row-fixed {
  background-color:rgba(0, 0, 255, 0.5);
}

div {
  background-color:rgba(0, 0, 0, 0.5);
  color: white;
}
 */

/* Other styles */

.side-pane {
    width: 400px;
    background-color: rgb(240, 240, 240);
}

h1 {
  font-size: 40px;
  margin: 0px !important; /*  UGLY: Overwriting boost default ... */
}

h1 a, h1 a:link, h1 a:visited {
  text-decoration-line: none;
  color:black
}

h1 a:hover, h1 a:focus, h1 a:active {
  text-decoration-line: underline;
  color:black
}

h1, .default-padding {
  padding: 10px 20px;
}

.subtitle {
  font-size: 20px;
  color: darkgray
}

div {
  direction: rtl;
  text-align: right;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.viewport {
  overflow: hidden;
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
}

html,
body {
  height: 100%;
  margin: 0;
}

.footer {
  font-family: monospace;
  color: darkgray;
  background-color: beige;
  font-size: 10px;
  padding: 3px;
  text-align: left
}

.footer-links {
  float: right
}

.logo-in-bg {
  background: url(../public/surfboard-bg.svg);
  background-size: auto 80%;
  background-repeat: no-repeat;
  background-position: center;
}

/** Spinner */
.loader {
  border: 8px solid #f3f3f3; /* Light grey */
  border-top: 8px solid grey;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 2s linear infinite;
  /* Hack for centering */
  margin-right: 50%;
  margin-top: 50%;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

  /* Color coding for groups */
  .noun {
    --fg-color: #3F51B5;
    --bg-color-2: #C5CAE9;
    --bg-color: #E8EAF6;
  }
  .verb {
    --fg-color: #009688;
    --bg-color-2: #B2DFDB;
    --bg-color: #E0F2F1;
  }
  .adj {
    --fg-color:#FFC107;
    --bg-color-2: #FFECB3;
    --bg-color: #FFF8E1;
  }
</style>
